import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="stellco_footer__privacy">
      <h1 className="stellco_footer__privacy___statement heading">
        Privacy Policy for [Stell Coffee & Tea (Stell Co. Inc)] Mobile App
      </h1>

      <p className="stellco_footer__privacy___statement strong">
        Powered by Toast
      </p>

      <p className="stellco_footer__privacy___statement">
        Last Updated: 5/15/2025
      </p>

      <p className="stellco_footer__privacy___statement">
        This Privacy Policy describes how personal information is collected,
        used, and disclosed when you download and use the [Stell Coffee & Tea
        (Stell Co. Inc)] Mobile App <strong>(the “App”)</strong>, and the
        choices and rights you have to protect your personal information
        collected via the App.
      </p>

      <p className="stellco_footer__privacy___statement">
        [Stell Coffee & Tea (Stell Co. Inc)] (“Stell Coffee & Tea (Stell Co.
        Inc)”) is responsible for the personal information collected when you
        use the App. The App uses technology provided by Toast, Inc. (“Toast”).
        To learn more about Toasts privacy practices, please visit Toast's
        Privacy Statement at{" "}
        <a href="https://pos.toasttab.com/privacy">
          https://pos.toasttab.com/privacy
        </a>
        .
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Personal Information Collected Via the App
      </h2>

      <p className="stellco_footer__privacy___statement">
        The App collects the following categories of personal information.
      </p>

      <ul>
        <li>
          Contact information. You may submit your name, email, phone number,
          and address to the App.
        </li>
        <li>
          Orders and order history. The App collects and retains the orders you
          place via the App, including the items you order, date and time of the
          order, order amounts, delivery locations, tips, order frequency,
          favorite restaurant locations or menu items, and any preferences or
          selections you submit with your order.
        </li>
        <li>
          Payment information. You may input your payment card information,
          including your card number, security code, and expiration date, or
          provide other payment information (such as Apple Pay or Google Pay).
        </li>
        <li>
          Precise location. If you choose to enable it, the App will collect
          your precise location information to provide you with certain
          location-enabled features, such as to display and alert you to
          restaurants nearby and provide live map views. You can disable precise
          location at any time through your device settings.
        </li>
        <li>
          Rewards program and gift cards. If you participate in Stell Coffee &
          Tea (Stell Co. Inc)'s rewards program or any other reward program
          supported by Stell Coffee & Tea (Stell Co. Inc) or the App, the App
          collects information about your rewards program status[, including
          your points balance and redemptions]. The App also collects
          information about any gift cards you receive or send, including the
          value of the card and balances.
        </li>
        <li>
          Device and usage information. The App automatically logs information
          about you, your mobile device, and your interaction over time with the
          App. This includes: device information, such as your device type,
          browser type, IP address, device identifiers, language
          settings,carrier, and general location information; and usage
          information, such as screens you viewed, how long you spent on a page,
          browsing history, and access times, and page clicks, page scrolls, and
          page element interactions. The App also send crash reports in the
          event of an error for analysis and troubleshooting purposes.
        </li>
      </ul>

      <h2 className="stellco_footer__privacy___statement">
        How Your Personal Information is Used
      </h2>

      <p className="stellco_footer__privacy___statement">
        Stell Coffee & Tea (Stell Co. Inc) may use your personal information for
        the following purposes:
      </p>

      <ul>
        <li>
          To provide the App and any features you use. This includes
          authenticating your access to the App; administering your account;
          allowing you to place orders and remember your preferences; processing
          transactions; and providing any features that you use within the App,
          such as location-enabled features and access to loyalty program
          benefits.
        </li>

        <li>
          To personalize your experience in the App and provide recommendations.
          This includes personalizing the items you see displayed in the App and
          recommending restaurant locations and menu items that may interest you
          based on your past orders and preferences. The App may also send you
          notifications of locations or items that may interest you. You can
          control notifications in your device or App settings.
        </li>

        <li>
          Troubleshooting and App improvement. Your information may be used to
          analyze the performance of the App, identify and correct errors, and
          develop and improve App features and functionality. Your information
          may also be aggregated with other users' information, or otherwise
          anonymized, to create statistics or for other lawful business
          purposes, including analytics, forecasting, and strategic planning.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement">
        Stell Coffee & Tea (Stell Co. Inc) may also use personal information
        collected through the App for the following purposes:
      </p>

      <ul>
        <li>
          To analyze users' selections and preferences in order to improve Stell
          Coffee & Tea (Stell Co. Inc)'s offerings, identify opportunities for
          growth, and conduct market research;
        </li>

        <li>
          To send you marketing communications outside the App (including by
          email, text message or other channels) and to advertise to you and
          others with similar interests on third-party websites and platforms;
          and
        </li>

        <li>
          For compliance and protection, including to enforce any Applicable
          terms and conditions, comply with legal obligations, defend against
          legal claims or disputes, protect the security and integrity of the
          App, and identify and investigate fraudulent, harmful, unauthorized,
          unethical or illegal activity.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement">
        These uses outside the App are just examples and may not reflect all the
        ways Stell Coffee & Tea (Stell Co. Inc) uses personal information
        outside the App. To learn more, please contact Stell Coffee & Tea (Stell
        Co. Inc) directly.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        How Your Information Is Shared
      </h2>

      <p className="stellco_footer__privacy___statement">
        Personal information collected via the App may be shared as follows:
      </p>

      <ul>
        <li>
          Sharing with Toast. Because the App is operated by Toast, any
          information you provide via the App, or that Stell Coffee & Tea (Stell
          Co. Inc) inputs to the App, may be hosted and stored by Toast on Stell
          Coffee & Tea (Stell Co. Inc)'s behalf.
        </li>

        <li>
          Service providers. The App relies on other service providers that are
          needed to administer and support the App and its features, including
          hosting services, communications, data and cyber security services,
          payment processing services, identity verification, fraud detection,
          investigation and prevention services, and customer relationship
          management systems.
        </li>

        <li>
          Sharing initiated by Stell Coffee & Tea (Stell Co. Inc). The App may
          share information with partners selected by Stell Coffee & Tea (Stell
          Co. Inc), such as delivery services and loyalty programs offered by
          third parties. Stell Coffee & Tea (Stell Co. Inc) may also share
          information with advertising partners, including via pixels and
          similar technologies, to allow Stell Coffee & Tea (Stell Co. Inc) to
          advertise to you and others with similar interests on third-party
          websites and platforms.
        </li>

        <li>
          Authorities and others. Your personal information may be shared with
          law enforcement, government authorities, and private parties, where
          required by law or necessary or Appropriate to protect legal rights or
          the security or integrity of the App.
        </li>
      </ul>

      <h2 className="stellco_footer__privacy___statement">
        Your Privacy Choices
      </h2>

      <p className="stellco_footer__privacy___statement">
        Within your App settings, you have the following choices regarding your
        personal information:
      </p>

      <ul>
        <li>
          <strong>Access, change your account information.</strong> You may
          access your personal information through your account on the App. You
          can also correct account information that is out of date or
          inaccurate.
        </li>

        <li>
          <strong>Delete your account.</strong> To delete your account, follow
          the instructions within the App settings page.
        </li>

        <li>
          <strong>Additional rights and choices.</strong> To disable third-party
          advertising pixels and similar technologies, visit the privacy page in
          your App settings. Stell Coffee & Tea (Stell Co. Inc) may offer
          additional choices and allow you to exercise any rights accorded to
          you under Applicable laws. For more information, please contact Stell
          Coffee & Tea (Stell Co. Inc) directly.
        </li>
      </ul>

      <p>
        <strong>Do Not Track.</strong> Some Internet browsers may be configured
        to send “Do Not Track” signals to the online services that you visit.
        The App does not respond to "Do Not Track" signals. To find out more
        about "Do Not Track," please visit{" "}
        <a href="http://www.allaboutdnt.com">http://www.allaboutdnt.com</a>.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Changes to This Privacy Policy
      </h2>

      <p className="stellco_footer__privacy___statement">
        This Privacy Policy may be modified at any time. You will be notified of
        any material changes to the Privacy Policy in accordance with Applicable
        laws.
      </p>

      <h2 className="stellco_footer__privacy___statement">Contact Us</h2>

      <p className="stellco_footer__privacy___statement">
        For any questions about the privacy practices described in this Privacy
        Policy, please contact [ Stell Coffee & Tea ( Stell Co. Inc ) ] at: [
        robbie@stell.co ]
      </p>

      <h2 className="stellco_footer__privacy___statement">
        California Addendum
      </h2>

      <p className="stellco_footer__privacy___statement">
        This California Addendum supplements the Privacy Policy for [Stell
        Coffee & Tea (Stell Co. Inc)] Mobile App and applies only to personal
        information collected via the App that relates to California residents
        and is regulated by the California Consumer Privacy Act (“CCPA”).
      </p>

      <h2 className="stellco_footer__privacy___statement">
        CCPA Categories of Personal Information
      </h2>

      <p className="stellco_footer__privacy___statement">
        The App collects the following categories of personal information:
      </p>

      <table border={1}>
        <thead>
          <tr border={1}>
            <td>
              <strong>Data Category Collected</strong>
            </td>
            <td>
              <strong>Collected ?</strong>
            </td>
            <td>
              <strong>Primary Purposes of Processing</strong>
            </td>
            <td>
              <strong>Key Disclosures</strong>
            </td>
            <td>
              <strong>Can You Limit Sharing?</strong>
            </td>
          </tr>
        </thead>

        <tbody>
          <tr border={1}>
            <td>Identifiers, such as name, email address, and IP address</td>
            <td>Yes</td>
            <td>
              To provide the App and any features you use. To personalize your
              experience in the App and provide recommendations. Troubleshooting
              and App improvement.
            </td>
            <td>Toast and other service providers</td>
            <td>No</td>
          </tr>
          <tr border={1}>
            <td>
              Personal information categories listed in the California Customer
              Records Statute (e.g., name, contact details)
            </td>
            <td>Yes</td>
            <td>
              To provide the App and any features you use. To personalize your
              experience in the App and provide recommendations. Troubleshooting
              and App improvement.
            </td>
            <td>Toast and other service providers</td>
            <td>No</td>
          </tr>
          <tr border={1}>
            <td>Protected characteristics under California or federal law</td>
            <td>No</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr border={1}>
            <td>Protected characteristics under California or federal law</td>
            <td>No</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr border={1}>
            <td>
              Personal information categories listed in the California Customer
              Records Statute (e.g., name, contact details)
            </td>
            <td>Yes</td>
            <td>
              To provide the App and any features you use. To personalize your
              experience in the App and provide recommendations. Troubleshooting
              and App improvement.
            </td>
            <td>Toast and other service providers</td>
            <td>No</td>
          </tr>
          <tr border={1}>
            <td>Professional or employment-related information</td>
            <td>No</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr border={1}>
            <td>Biometric information</td>
            <td>No</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr border={1}>
            <td>
              Internet or other electronic network activity information,
              including but not limited to browsing history and search history
            </td>
            <td>Yes</td>
            <td>
              To provide the App and any features you use. To personalize your
              experience in the App and provide recommendations. Troubleshooting
              and App improvement.
            </td>
            <td>Toast and other service providers</td>
            <td>No</td>
          </tr>
          <tr border={1}>
            <td>Geolocation data</td>
            <td>Yes</td>
            <td>
              To provide the App and any features you use. To personalize your
              experience in the App and provide recommendations. Troubleshooting
              and App improvement.
            </td>
            <td>Toast and other service providers</td>
            <td>No</td>
          </tr>
          <tr border={1}>
            <td>
              Audio, electronic, visual, thermal, olfactory, or similar
              information
            </td>
            <td>No</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr border={1}>
            <td>Education records</td>
            <td>No</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr border={1}>
            <td>
              Inferences drawn from information to create a profile about your
              behavior, preferences, etc.
            </td>
            <td>Yes</td>
            <td>
              To provide the App and any features you use. To personalize your
              experience in the App and provide recommendations. Troubleshooting
              and App improvement.
            </td>
            <td>Toast and other service providers</td>
            <td>No</td>
          </tr>
        </tbody>
      </table>

      <p className="stellco_footer__privacy___statement strong">
        Additional Purposes of Processing
      </p>

      <p className="stellco_footer__privacy___statement">
        Stell Coffee & Tea (Stell Co. Inc) may also use personal information
        collected through the App for the following purposes:
      </p>

      <ul>
        <li>
          To analyze users' selections and preferences in order to improve Stell
          Coffee & Tea (Stell Co. Inc)'s offerings, identify opportunities for
          growth, and conduct market research;
        </li>

        <li>
          To send you marketing communications outside the App (including by
          email, text message or other channels) and to advertise to you and
          others with similar interests on third-party websites and platforms;
          and
        </li>

        <li>
          For compliance and protection, including to enforce any applicable
          terms and conditions, comply with legal obligations, defend against
          legal claims or disputes, protect the security and integrity of the
          App, and identify and investigate fraudulent, harmful, unauthorized,
          unethical or illegal activity.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement">
        These uses outside the App are just examples and may not reflect all the
        ways Stell Coffee & Tea (Stell Co. Inc) uses personal information
        outside the App. To learn more, please contact Stell Coffee & Tea (Stell
        Co. Inc) directly.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Additional Disclosures of Personal Information
      </h2>

      <p className="stellco_footer__privacy___statement">
        Stell Coffee & Tea (Stell Co. Inc) may also share personal information
        with third parties as follows:
      </p>

      <ul>
        <li>
          Sharing initiated by Stell Coffee & Tea (Stell Co. Inc). The App may
          share information with partners selected by Stell Coffee & Tea (Stell
          Co. Inc), such as delivery services and loyalty programs offered by
          third parties. Stell Coffee & Tea (Stell Co. Inc) may also share
          personal information with acquirers and other relevant participants in
          business transactions (or negotiations for such transactions)
          involving a corporate divestiture, merger, consolidation, acquisition,
          reorganization, sale, or other disposition of all or any portion of
          the business.
        </li>

        <li>
          Authorities and others. Your personal information may be shared with
          law enforcement, government authorities, and private parties, where
          required by law or necessary or appropriate to protect legal rights or
          the security or integrity of the App.
        </li>
      </ul>

      <h2 className="stellco_footer__privacy___statement">
        Your Privacy Choices
      </h2>

      <p className="stellco_footer__privacy___statement">
        The CCPA grants California residents the following rights:
      </p>

      <ul>
        <li>
          Information. You may have the right to obtain information about how
          your personal information is collected, used, and disclosed. This
          information is available within this Privacy Policy.
        </li>

        <li>
          Access, correction and deletion. You may also have the right to
          request access to your personal information, to correct personal
          information that is out of date or inaccurate, or to delete personal
          information that is no longer needed for a permitted purpose.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement">
        Please note that your ability to invoke the rights above are limited
        pursuant to the scope and limitations of the CCPA, including any
        available exceptions. For example, an access request can only be made
        twice within a 12-month period.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Sensitive Personal Information
      </h2>

      <p className="stellco_footer__privacy___statement">
        The App may collect sensitive personal information as follows:
      </p>

      <ul>
        <li>
          <strong>Precise location.</strong> If you choose to enable it, the App
          will collect your precise location information to provide you with
          certain location-enabled features, such as to display and alert you to
          restaurants nearby and provide live map views. You can disable precise
          location at any time through your device settings.
        </li>

        <li>
          <strong>Dietary and dining preferences.</strong> Your dietary and
          dining preferences may reveal sensitive personal information about
          you, such as your allergies, accessibility requirements, and religious
          beliefs. You can submit this information to the App to allow the Stell
          Coffee & Tea (Stell Co. Inc) to better serve your needs and
          preferences.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement strong">
        Right to Limit the Use of Sensitive Personal Information
      </p>

      <p className="stellco_footer__privacy___statement">
        The CCPA grants California residents the right to limit the use of
        sensitive personal information beyond certain permitted purposes. In
        general, your sensitive personal information is used only for the
        limited purposes of providing and personalizing the App for you.
      </p>

      <h2 className="stellco_footer__privacy___statement strong">
        Personal Information Retention
      </h2>

      <p className="stellco_footer__privacy___statement">
        Your personal information is retained for as long as is necessary to
        allow you to access and use the App and for a reasonable time thereafter
        for the purposes described in the Privacy Policy. Your personal
        information will be deleted or destroyed when its continued retention is
        no longer reasonable necessary and proportionate in accordance with
        applicable laws.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        US State Law Addendum
      </h2>

      <p className="stellco_footer__privacy___statement">
        This US State Law Addendum supplements the Privacy Policy for [Stell
        Coffee & Tea (Stell Co. Inc)] Mobile App and applies only to personal
        information collected via the App that relates to Virginia, Colorado,
        Connecticut, Texas, Montana, Oregon, and Utah residents and is regulated
        by applicable consumer privacy laws in such states (“US State Privacy
        Laws”).
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Additional Rights Under US State Privacy Laws
      </h2>

      <p className="stellco_footer__privacy___statement">
        Where applicable, US State Privacy Laws grant consumers the following
        rights:
      </p>

      <ul>
        <li>
          <strong>Information.</strong> You may have the right to obtain
          information about how your personal information is collected, used,
          and disclosed. This information is available within this Privacy
          Policy.
        </li>

        <li>
          <strong>Access, correction and deletion.</strong> You may also have
          the right to request access to your personal information, to correct
          personal information that is out of date or inaccurate, or to delete
          personal information that is no longer needed for a permitted purpose.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement">
        To make a request, please consult the <strong>“Contact Us”</strong>{" "}
        section of the Privacy Policy. You may be asked for specific information
        from you to confirm your identity.
      </p>

      <p className="stellco_footer__privacy___statement">
        Please note that your ability to invoke the rights above are limited
        pursuant to the scope and limitations of the US State Privacy Laws,
        including any available exceptions. If you are not satisfied with how
        your request was addressed, you may consult the “Contact Us” section of
        the Privacy Policy to appeal and submit a complaint.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Sensitive Personal Information
      </h2>

      <p className="stellco_footer__privacy___statement">
        The App may collect and use sensitive personal information as follows:
      </p>

      <ul>
        <li>
          <strong>Precise location.</strong> If you choose to enable it, the App
          will collect your precise location information to provide you with
          certain location-enabled features, such as to display and alert you to
          restaurants nearby and provide live map views. You can withdraw your
          consent at any time by disabling precise location collection within
          your device settings.
        </li>

        <li>
          <strong>Dietary and dining preferences.</strong> If you choose to
          submit information about you dietary or dining preferences, you may
          reveal sensitive personal information about you, such as your
          allergies, accessibility requirements, and religious beliefs. By
          providing this information within the App, you consent to Stell Coffee
          & Tea (Stell Co. Inc)'s use of this information to better serve your
          needs and preferences. You can withdraw consent at any time by
          deleting such information within your profile in the App.
        </li>
      </ul>

      <p className="stellco_footer__privacy___statement">
        Please note that your withdrawal of consent will not affect use of your
        information before you withdrew your consent.
      </p>

      <h2 className="stellco_footer__privacy___statement">
        Personal Information Retention
      </h2>

      <p className="stellco_footer__privacy___statement">
        Your personal information is retained for as long as is necessary to
        allow you to access and use the App and for a reasonable time thereafter
        for the purposes described in the Privacy Policy. Your personal
        information will be deleted or destroyed when its continued retention is
        no longer reasonable necessary and proportionate in accordance with
        applicable laws.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
